<template>
  <div
    :class="`trade-last-orders-container--${type}`"
    class="trade-last-orders-container"
  >
    <div
      class="
        trade-last-orders-container__row
        txt txt--color-03 txt--10px txt--height-16px bor--bottom bor--transp-01 pl-12 pr-12
      "
    >
      <div
        v-for="(th, ind) in columns"
        :key="ind"
        :class="{
          'txt--left' : ind === 'price',
          'txt--right' : ind === 'total',
        }"
        class="
          trade-last-orders-container__cell
          txt--on-one-row txt--weight-400
          pt-4
          pb-4
          txt--center
        "
      >
        <slot :name="`th-${ind}`" v-bind="columns">
          {{ compColumnValue(columns[ind]) }}
        </slot>
      </div>
    </div>

    <div class="trade-last-orders-container__table">
      <trade-last-orders-table
        v-if="type !== 'buy' && !isEmpty"
        :heading="columns"
        :rows-data="sellRows"
        :current-type="type"
        :scroll-to-bottom="type === 'all'"
        trade-type="sell"
        class="trade-last-orders-container__table-sell"
      />

      <div
        v-if="!isEmpty"
        :class="{'trade-last-orders-container__average--dark': isDarkTheme}"
        class="trade-last-orders-container__average bor--top bor--bottom bor--transp-01 pt-4 pb-4 pl-12 pr-12"
      >
        <!-- // OLD, DEPENDING ON PRICE
        <span
          :class="{
            'txt--green trade-last-orders-container__up': increase > 0,
            'txt--red trade-last-orders-container__down': increase < 0,
            'txt--grey trade-last-orders-container__middle': increase === 0,
          }"
          class="trade-last-orders-container__average-price txt--bold txt--14px"
        >
          <trade-type-arrow class="mr-4" />
          {{ price }}
        </span> -->

        <!-- NEW, DEPENDING ON BUY/SELL -->
        <span
          :class="{
            'txt--green trade-last-orders-container__up':
              latestTrade.tradeType === 'buy',
            'txt--red trade-last-orders-container__down':
              latestTrade.tradeType === 'sell',
            'txt--grey':
              latestTrade.tradeType !== 'sell' &&
              latestTrade.tradeType !== 'buy',
          }"
          class="trade-last-orders-container__average-price txt--bold txt--14px pl-12"
        >
          {{ $filters.shortifyNumber(price) }}
          <trade-type-arrow class="ml-4" />
        </span>
        <span
          :class="percentClass"
          class="
            trade-last-orders-container__percent
            txt--bold txt--14px txt--color-04 pr-12
          "
        >
          {{ parseFloat(change) > 0 ? '+' : '' }}{{ change + '%' }}
        </span>
      </div>

      <!-- <span
        v-if="isEmpty"
        class="txt txt--14px txt--color-03 txt--center m-24"
        v-text="$t('trade.noData')"
      /> -->

      <div
        v-if="isEmpty"
        class="txt txt--14px txt--color-03 txt--center"
      >
        <div class="flx flx--center p-24">
          <div class="flx flx--col flx--items-center">
            <img
              class="mb-12"
              src="@/assets/icons/table/folder.svg"
              alt="folder icon"
            >
            <span
              class="txt txt--14px txt--color-03 txt--center"
              v-text="$t('trade.noData')"
            />
          </div>
        </div>
      </div>

      <trade-last-orders-table
        v-if="type !== 'sell' && !isEmpty"
        :heading="columns"
        :rows-data="buyRows"
        :current-type="type"
        trade-type="buy"
        class="trade-last-orders-container__table-buy"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Decimal from 'decimal.js-light'

export default {
  name: 'TradeLastOrdersContainer',
  components: {
    TradeLastOrdersTable: () => import(/* webpackMode: "eager" */ '@/components/trade/trade-last-orders-elements/TradeLastOrdersTable.vue'),
    TradeTypeArrow: () => import(/* webpackMode: "eager" */ '@/assets/icons/trade-type-arrow.svg?inline'),
  },
  props: {
    type: {
      validator: v => ['all', 'sell', 'buy'].includes(v),
      required: true,
    },
  },
  data () {
    return {
      increase: 0,
    }
  },
  computed: {
    ...mapGetters({
      amountCurrency: 'pairs/amountCurrency',
      totalCurrency: 'pairs/totalCurrency',
      getCurrentPair: 'pairs/getCurrentPair',
      getCurrentPairName: 'pairs/getCurrentPairName',
    }),
    // ...mapGetters([
    //     'getCurrentPair',
    //     'getCurrentPairName',
    // ]),
    ...mapState({
      // pair: state => state.pairs.currentPair,
      sellRows (_, getters) {
        return this.rowsForDepth(getters, 'sell') || []
      },
      buyRows (_, getters) {
        return this.rowsForDepth(getters, 'buy') || []
      },
      isDarkTheme: state => state.darktheme.enabled,
    }),
    pair () {
      return this.getCurrentPairName
    },
    isEmpty () {
      return !this.sellRows.length && !this.buyRows.length
    },
    columns () {
      return {
        price: `${this.$t('trade.orders.price')} (${this.totalCurrency})`,
        amount: {
          value: `${this.$t('trade.orders.amount')} (${
            this.amountCurrency || ''
          })`,
          hideOnMobile: true,
        },
        total: `${this.$t('trade.orders.total')} (${this.totalCurrency || ''})`,
      }
    },
    avaragePrice () {
      return +this.price || +this.volumeFiat
        ? [this.price, '', this.volumeFiat]
        : []
    },
    change () {
      return this.getCurrentPair.change
    },
    latestTrade () {
      return (this.$store.getters['trade/tradeHistory'] || [])[0] || {}
    },
    price () {
      return this.latestTrade.price || 0
    },
    volumeFiat () {
      return this.getCurrentPair.volumeInMoney // .market.volumeInMoney || ''
    },
    percentClass () {
      const val = parseFloat(this.change || 0)
      if (val > 0) return 'txt--green'
      if (val < 0) return 'txt--red'
      if (val === 0) return 'txt--grey'
      return ''
    },
  },
  watch: {
    latestTrade: {
      handler (v = {}, o = {}) {
        const old = new Decimal(o.price || 0)
        const cur = new Decimal(v.price || 0)
        this.increase = (() => {
          if (old.isZero()) return 0 // no data yet -> grey
          if (cur.equals(old)) return 0 // same value -> grey
          if (cur.greaterThan(old)) return +1 // price increase -> green
          if (cur.lessThan(old)) return -1 // price decrees -> red
          return 0
        })()
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    rowsForDepth (getters, buyOrSell) {
      const getterFn = getters[`trade/${buyOrSell}Depth`]
      return {
        all: getterFn(this.pair),
        [buyOrSell]: getterFn(this.pair),
      }[this.type]
    },
    compColumnValue (col) {
      if (col instanceof Object) return col.value
      return col
    },
  },
}
</script>

<style lang="scss" scoped>
.trade-last-orders-container {
  $root: &;
  // $title-h: 64px;
  $average-block-height: 29px;

  // height: calc(100% - #{$title-h});

  &--all {
    #{$root}__table {
      overflow: auto;

      @include bp(l) {
        // height: 100%;
      }
    }
  }

  &__row {
    display: flex;
    align-items: center;
    // transform: translateY(-1px);
  }

  &__row &__cell:nth-child(2) {
    display: none;

    @include bp(m) {
      display: block;
    }
  }

  &__cell {
    flex: 1 1 0;
  }

  &__average {
    display: flex;
    justify-content: space-between;
    padding: 10px 0;
  }

  &__average--dark {
    box-shadow: 0px 0px 6px 1px var(--c-input-bg-auth);
    background-color: var(--c-input-bg-auth);
  }

  &__average-price {
    display: flex;
    align-items: center;
  }

  &__up svg {
    transform: rotate(180deg);
  }

  &__middle svg {
    transform: rotate(270deg);
  }

  &__change-trend {
    display: flex;
    align-items: center;
  }

  &__percent {
    display: none;
    @include bp(m) {
      display: initial;
    }
  }

  &__table {
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: hidden;

    height: calc(#{toRem(405px)} - #{$average-block-height});

    @include bp(l) {
      height: initial;
      // height: calc(100% - #{$average-block-height});
    }
  }

  &__table-sell {
    flex: 1;
    padding: 0 0 toRem(10px);
  }

  &__table-buy {
    flex: 1;
    padding: 0 0 toRem(10px);
  }
}
</style>
